/* eslint-disable jsx-a11y/anchor-is-valid */

import {Link} from 'react-router-dom'
import {KTIcon} from '../../../../_metronic/helpers'

type Props = {
  id: number
  selectItem: (selectType: string, id: number) => void
}

const RouteActionCell = ({id, selectItem}: Props) => {
  // const onEdit = () => selectItem('edit', id)
  const onDelete = () => selectItem('delete', id)
  const onView = () => selectItem('view', id)

  return (
    <div className='text-end'>
      <Link
        to={`/routes/update-route/${id}`}
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 mb-1'
        // onClick={onEdit}
      >
        <KTIcon iconName='pencil' className='fs-3' />
      </Link>
      {/* <a
        href='#'
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
        data-bs-toggle='modal'
        data-bs-target='#kt_modal_1'
        onClick={onView}
      >
        <KTIcon iconName='eye' className='fs-3' />
      </a> */}
      {/* <a
        href='#'
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
        data-bs-toggle='modal'
        data-bs-target='#kt_modal_2'
        onClick={onDelete}
      >
        <KTIcon iconName='trash' className='fs-3 text-warning' />
      </a> */}
    </div>
  )
}

export default RouteActionCell
